/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourceSurveyItemDto
 */
export interface SourceSurveyItemDto {
    /**
     * Source survey enum value (e.g., searchEngine, advertisement)
     * @type {string}
     * @memberof SourceSurveyItemDto
     */
    source: string;
    /**
     * Number of users from this source
     * @type {number}
     * @memberof SourceSurveyItemDto
     */
    usersCount: number;
    /**
     * Percentage of total users from this source
     * @type {number}
     * @memberof SourceSurveyItemDto
     */
    percentage: number;
}

export function SourceSurveyItemDtoFromJSON(json: any): SourceSurveyItemDto {
    return SourceSurveyItemDtoFromJSONTyped(json, false);
}

export function SourceSurveyItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourceSurveyItemDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'source': json['source'],
        'usersCount': json['usersCount'],
        'percentage': json['percentage'],
    };
}

export function SourceSurveyItemDtoToJSON(value?: SourceSurveyItemDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'source': value.source,
        'usersCount': value.usersCount,
        'percentage': value.percentage,
    };
}

